import * as React from 'react';

export const DotsIcon = ({
  ref,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  ref?: React.RefObject<SVGSVGElement>;
}) => (
  <svg
    width='3'
    height='11'
    viewBox='0 0 3 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    ref={ref}
    {...props}
  >
    <circle cx='1.125' cy='1.42493' r='1.125' fill='#586A7D' />
    <circle cx='1.125' cy='5.42493' r='1.125' fill='#586A7D' />
    <circle cx='1.125' cy='9.42493' r='1.125' fill='#586A7D' />
  </svg>
);
